import { Component, input, output } from '@angular/core';
import { ButtonComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';

/**
 * Primary action row for the create-shipment address step.
 */
@Component({
  selector: 'app-shipment-form-actions',
  imports: [ButtonComponent, TranslatePipe],
  templateUrl: './shipment-form-actions.html',
  styleUrl: './shipment-form-actions.scss',
})
export class ShipmentFormActions {
  readonly disabled = input(false);
  /** True while AVS and serviceability validation is in flight after Save and Continue. */
  readonly loading = input(false);
  readonly saveRequested = output<void>();

  /**
   * Emits when Save and Continue is activated.
   */
  protected onSaveAndContinue(): void {
    if (this.disabled() || this.loading()) {
      return;
    }

    this.saveRequested.emit();
  }
}
